import * as React from "react";

// Root container
export const Breadcrumb = ({ children, className = "", ...props }) => {
  return (
    <nav
      aria-label="breadcrumbs"
      className={`flex items-center text-sm ${className}`}
      {...props}
    >
      {children}
    </nav>
  );
};

// List wrapper
export const BreadcrumbList = ({ children, className = "", ...props }) => {
  return (
    <ol
      className={`flex items-center gap-2 ${className}`}
      {...props}
    >
      {children}
    </ol>
  );
};

// Individual breadcrumb
export const BreadcrumbItem = ({ children, className = "", ...props }) => {
  return (
    <li className={`inline-flex items-center ${className}`} {...props}>
      {children}
    </li>
  );
};

// Link breadcrumb
export const BreadcrumbLink = ({ href, children, className = "", ...props }) => {
  return (
    <a
      href={href}
      className={`hover:underline hover:cursor-pointer ${className}`}
      {...props}
    >
      {children}
    </a>
  );
};

// Separator (› or / or custom)
export const BreadcrumbSeparator = ({ children = "/", className = "", ...props }) => {
  return (
    <span
      role="presentation"
      className={`mx-1 text-gray-400 ${className}`}
      {...props}
    >
      {children}
    </span>
  );
};
